import {Tree, Table, Row, Col, Button, Input, Checkbox, Modal, Form, message,Popover} from "antd";
import React from "react";
import { connect } from 'react-redux'
import {postPublic} from "../actions";
import { Scrollbars } from 'react-custom-scrollbars';
import {EditableTagGroup} from "./editableTagGroup";
import './weChatFans.scss'
import {applicationName} from "../utils";

const { TreeNode }= Tree;
const { Search } = Input;
// 滚动条参数
const scroll = {
    // 如果最终结果表格内容与表格头部无法对齐。
    // 表格头需要增加空白列，弹性布局
    width: '100%',
    // 最大高度，内容超出该高度会出现滚动条
    height: document.body.clientHeight - 322,
}
/**
 * 粉丝列表
 */
class WeChatFans extends React.Component{

    columns = [
        {
            key: 'headimgurl',
            title: '头像',
            dataIndex: 'headimgurl',
            render: (text, record) => (
                <span><img src={text} width={32} height={32}/></span>
            ),
            width: '10%'
        },{
            key: 'nickname',
            title: '昵称',
            dataIndex: 'nickname',

            align: 'center',
            className:'fans-manage-table-column-nickname',
            width: '20%'
        },{
            key: 'tagNames',
            title: '标签',
            dataIndex: 'tagNames',
            align: 'center',
            render: (text, record) =>(
                <EditableTagGroup tags={text} newTagVisible={false} tagsClosable={false} />
            ),
            className:'fans-manage-table-column-tags'
        },{
            key: 'remark',
            title: '备注',
            dataIndex: 'remark',
            align: 'center',
            className:'fans-manage-table-column-remark',
            width: '10%',
            render: (text) => <span title={text}>{text}</span>
        }, {
            key: 'option',
            title: '操作',
            dataIndex: 'option',
            align: 'center',
            render: (text, record) => (
                <>
                <span onClick={() => this.tagToUser(record,this.state.currentMediaCode)}>打标签</span>
                <span onClick={() => this.updateRemark(record,this.state.currentMediaCode)}>修改备注</span>
                </>
            ),
            className:'fans-manage-table-column-action',
            width: '20%'
        }
        ];

    constructor(props){
        super(props);
    }

    // 滚动结束，记下滚动位置
    handleScrollStop = () => {
        if (this.scrollbarsRef.current){
            this.scrollTop = this.scrollbarsRef.current.getScrollTop();
        }
    };

    // 组件重新渲染，重新设置滚动条的位置
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.scrollbarsRef.current){
            this.scrollbarsRef.current.scrollTop(this.scrollTop);
        }
    }

    defaultValue ={
        start : 1,
        size : 10,
    };

    state = {
        ...this.defaultValue,
        total : 0,
        data : [],
        selectedRows : [],
        loading : true,
        currentMediaCode: this.props.currentMediaCode,
        groupId: this.props.groupId,
        tableHeight:  document.body.clientHeight - 280,
        queryStr: ""
    };

    componentDidMount() {
        //  覆盖ant design 自带滚动条样式
        document.querySelector('.ant-table-scroll > .ant-table-body').style.overflow='hidden';
        // 滚动条组件ref，重新设置滚动位置
        this.scrollbarsRef = React.createRef();
        this.loadData(this.state.start, this.state.size, this.state.currentMediaCode, this.state.groupId,this.state.queryStr);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        //  覆盖ant design 自带滚动条样式
        document.querySelector('.ant-table-scroll > .ant-table-body').style.overflow='hidden';
        // 滚动条组件ref，重新设置滚动位置
        this.scrollbarsRef = React.createRef();
        this.setState({
            ...this.defaultValue,
            mediaCode: nextProps.currentMediaCode,
            groupId: nextProps.groupId
        });
        this.loadData(this.defaultValue.start, this.defaultValue.size, nextProps.currentMediaCode, nextProps.groupId,this.state.queryStr);
    }

    reloadDate = () => {
        this.loadData(this.state.start, this.state.size, this.state.currentMediaCode, this.state.groupId,this.state.queryStr);
    };

    loadData = (start, size, mediaCode, tagId, queryStr) =>{
        this.setState({
            loading: true
        });
        let url = "/cm-sites-" + applicationName() + "/getWeChatFans";
        let param = {start:start, size: size, mediaCode, tagId : tagId, queryStr: queryStr};
        postPublic(url, param,(res) =>{
            this.setState(prevState => {
                return {
                    ...prevState,
                    start: start,
                    size: size,
                    total: res.count,
                    data: res.data,
                    loading: false
                }
            })
        });
    };

    tagToUser = (record,mediaCode) => {
        this.refs.tagModal.showModal(record,mediaCode,this.reloadDate);
    };

    updateRemark = (record,mediaCode) => {
        this.refs.remarkModal.showModal(record,mediaCode,this.reloadDate);
    };

    // onSelect = (record, selected, selectedRows, nativeEvent) => {
    //     this.state.selectedRows = selectedRows;
    // };

    // onSelectAll = (selected, selectedRows, changeRows) => {
    //     this.state.selectedRows = selectedRows;
    // };

    search = (value) =>{
        this.loadData(1,10,this.state.currentMediaCode,this.state.groupId,value);
    };

    syncWeiChatFans = () =>{
        this.setState({
            loading: true
        });
        let url = "/cm-sites-" + applicationName() + "/syncWeChatTagAndFans";
        let param = {"mediaCode":this.state.currentMediaCode};
        postPublic(url, param,(res) =>{
            this.setState({
                ...this.defaultValue,
                loading: false
            });
            this.reloadDate();
            this.props.loadData();
        });
    };

    render() {
        // 词法作用域
        const self = this;
        // 用react-custom-scrollbars包裹住表格内容
        const components = {
            table (props) {
                const { className } = props;
                return (
                    <Scrollbars
                        style={scroll}
                        onScrollStop={self.handleScrollStop}
                        ref={ self.scrollbarsRef } >
                        <table className={className}>
                            { props.children }
                        </table>
                    </Scrollbars>
                )
            }
        };
        let pagination = {
            onChange: (page, pageSize) => this.loadData(page, pageSize, this.state.currentMediaCode,this.state.groupId,this.state.queryStr),
            onShowSizeChange: (page, pageSize) => this.loadData(page, pageSize, this.state.currentMediaCode,this.state.groupId,this.state.queryStr),
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.start,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
        };
        const { newSecondSelectColor } = this.props;
        return (

            <div className="left">
                <div className="top">
                <Button type="primary"  onClick={this.syncWeiChatFans}>同步粉丝<img style={{ marginLeft: '6px', width: '14px'}} src="images/fresh.png"  alt=""/></Button>
                        <Search
                            placeholder="用户昵称"
                            onSearch={this.search}
                            style={{ width: 300 }}
                        />

                </div>
                <div className="content">
                <Table
                    columns={this.columns}
                    scroll={{y: this.state.data.length > 0 ? scroll.height : 1}}
                    dataSource={this.state.data}
                    pagination={pagination}
                    loading={this.state.loading}
                    components={components}
                    className="fans-manage-table"
                    //rowClassName="fans-manage-table-row"
                    // rowSelection={{
                    //     onSelect: this.onSelect,
                    //     onSelectAll: this.onSelectAll
                    // }}
                    style={{marginTop:10}}/>
                    <TagModal ref={"tagModal"}/>
                    <RemarkModal ref={"remarkModal"}/>
                </div>
            </div>
            // <div style={{padding:10}}>
            //     <Search
            //         placeholder="用户昵称"
            //         onSearch={this.search}
            //         style={{ width: 300 }}
            //     />
            //     <Button type="primary" style={{marginLeft:10}} onClick={this.syncWeiChatFans}>同步粉丝</Button>
            //     <TagModal ref={"tagModal"}/>
            //     <RemarkModal ref={"remarkModal"}/>

            //     <Table
            //         columns={this.columns}
            //         scroll={{y: this.state.data.length > 0 ? scroll.height : 1}}
            //         dataSource={this.state.data}
            //         pagination={pagination}
            //         loading={this.state.loading}
            //         components={components}
            //         // rowSelection={{
            //         //     onSelect: this.onSelect,
            //         //     onSelectAll: this.onSelectAll
            //         // }}
            //         style={{marginTop:10}}/>
            // </div>
        );
    }
}

WeChatFans.defaultProps = {
    newSecondSelectColor: '#0050B3'
}



/**
 * 标签树
 */
class WeChatTagTree extends React.Component{

    constructor(props){
        super(props);
        this.loadData();
    }

    state = {
        data: [],
        checkedTagId : 0,
        checkedTagName: "",
        currentMediaCode: this.props.currentMediaCode,
        moreButtonVisible:false
    };

    loadData = (tagName) =>{
        let url = "/cm-sites-" + applicationName() + "/getWeChatTags";
        postPublic(url, {mediaCode: this.state.currentMediaCode},(res) =>{
            this.setState({
                data : res,
                checkedTagName: tagName || ""
            });
        });
    };

    addTag = () => {
        this.refs.tagManageModal.showModal("新增标签",0,"",this.state.currentMediaCode,this.loadData);
    };

    renameTag = () => {
        let renameTagId = this.state.checkedTagId;
        if(!renameTagId || renameTagId < 10){
            Modal.error({
                title: '请先选择要重命名的标签',
                okText:"确定"
            });
            return;
        }
        this.refs.tagManageModal.showModal("重命名标签",this.state.checkedTagId,this.state.checkedTagName,this.state.currentMediaCode,this.loadData);
    };

    removeTag = () => {
        let removeTagId = this.state.checkedTagId;
        if(!removeTagId || removeTagId < 10){
            Modal.error({
                title: '请先选择要删除的标签',
                okText:"确定"
            });
            return;
        }
        if(removeTagId === "2"){
            Modal.warn({
                title: '星标组不可删除',
                okText:"确定"
            });
            return;
        }
        Modal.confirm({
            title: '删除标签',
            content: '删除标签后，该标签下的所有用户将失去该标签属性。是否确定删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: ()=>{
                let url = "/cm-sites-" + applicationName() + "/deleteTag";
                postPublic(url, {mediaCode: this.state.currentMediaCode,groupId: removeTagId},(res) =>{
                    if(res){
                        this.loadData();
                        this.props.reloadFansTable();
                    }
                });
            }
        });
    };

    onSelect = (selectedKeys, e) => {
        if(e.selectedNodes[0]){
            this.setState({
                checkedTagId : selectedKeys[0],
                checkedTagName: e.selectedNodes[0].props.title
            });
            this.props.onSelect(selectedKeys, e);
        }
    };

    moreButtonDisplay = () =>{
        this.setState({
            moreButtonVisible: !this.state.moreButtonVisible
        })
    };

    render() {
        const {newSecondSelectColor } = this.props;
        console.log(this.props)
        return (
            <div className="right">
                <Button type="primary" style={{marginRight:5}} onClick={this.addTag}>添加标签</Button>
                <style>
                        {`
            .ant-btn-primary{
               
            background-color:${newSecondSelectColor} !important;
            border-color:${newSecondSelectColor} !important;
            }
                             `}</style>
                <Popover visible={this.state.moreButtonVisible} content={
                    <div style={{marginTop: 5}} >
                        <Button type="primary" style={{marginRight:5}} onClick={this.renameTag}>重命名</Button>
                        <Button type="primary" onClick={this.removeTag}>删除</Button>
                    </div>}>
                    <Button icon={"more"} style={{lineHeight:"30px"}} onClick={this.moreButtonDisplay.bind(this)}></Button>
                </Popover>

                <TagManageModal ref={"tagManageModal"}/>
                <div style={{marginTop:10,height:document.body.clientHeight - 165,overflow:"auto"}}>
                <Scrollbars>
                <Tree
                    defaultExpandAll={true}
                    onSelect={this.onSelect}
                    className="fans-manage-tree">
                    <TreeNode title="全部标签" key="0">
                        {
                            this.state.data.map( tag => (
                                <TreeNode title={tag.name} key={tag.groupId} />
                            ))
                        }
                    </TreeNode>
                </Tree>
                </Scrollbars>
                </div>
            </div>
        );
    }
}

class WeChatFansManage extends React.Component{

    state = {
        groupId: 0,
        currentMediaCode : this.props.match.params.currentMedia
    };

    onSelect = (selectedKeys, e) => {
        this.setState({
            groupId: selectedKeys[0]
        });
    };

    reloadTagTree = () => {
        this.refs.tagTree.loadData();
    };

    reloadFansTable = () => {
        this.setState({
            groupId: 0
        });
    };

    render() {
        let height = window.innerHeight - 80;
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (
            <div className="fans-manager" style={{ height }}>
                <div className="fans-manager-title">粉丝管理</div>
                <div style={{ height: 'calc( 100% - 44px )', display:'flex'}}>
                    <div style={{ width: 'calc( 100% - 300px )'  }} >
                        <WeChatFans newSecondSelectColor={newSecondSelectColor} currentMediaCode={this.state.currentMediaCode} groupId={this.state.groupId} loadData={ this.reloadTagTree }/>
                    </div>
                    <div style={{ width: '300px' }} >
                        <WeChatTagTree newSecondSelectColor={newSecondSelectColor} onSelect={this.onSelect} currentMediaCode={this.state.currentMediaCode} ref="tagTree" reloadFansTable={this.reloadFansTable}/>
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * 标签弹窗
 */
class TagModal extends React.Component{

    constructor(props){
        super(props);
    }

    state = {
        visible: false,
        currentMediaCode: "",
        openId : "",
        fansTagIds:[],
        allTags: [],
        checkedTagsId:[],
        confirmLoading : false
    };

    okCallBack = () =>{};

    showModal = (record, mediaCode,okCallBack) => {
        this.setState({
            visible: true,
            currentMediaCode: mediaCode,
            openId: record.openid,
            fansTagIds:record.tagidList
        });
        this.okCallBack = okCallBack;
        this.loadData(mediaCode);
    };

    handleOk = e => {
        console.log(e);
        this.setState({
            confirmLoading: true,
        });
        let saveTagUrl = "/cm-sites-" + applicationName() + "/saveWeChatFansTags";
        postPublic(saveTagUrl, {mediaCode: this.state.currentMediaCode,openIds:this.state.openId,tagIds:this.state.checkedTagsId},(res) =>{
            if(res){
                this.setState({
                    visible: false,
                    currentMediaCode : "",
                    openId : "",
                    checkedTagsId:[],
                    confirmLoading: false
                });
                this.okCallBack();
            }
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
            currentMediaCode : "",
            openId : "",
            checkedTagsId:[]
        });
    };

    loadData = (mediaCode) => {
        let getAllTagsUrl = "/cm-sites-" + applicationName() + "/getWeChatTags";
        postPublic(getAllTagsUrl, {mediaCode: mediaCode},(res) =>{
            this.setState({
                allTags : res
            });
        });
    };

    onChange = (checkedValues) => {
        this.setState({
            checkedTagsId : checkedValues
        })
    };

    render() {
        let options = [];
        this.state.allTags.map( tag =>{
            options.push({ label: tag.name, value: tag.groupId})
        });
        return (
            <Modal
                title="标签选择"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                confirmLoading={this.confirmLoading}
                destroyOnClose
            >
                <Checkbox.Group
                    options={options}
                    onChange={this.onChange}
                    defaultValue={this.state.fansTagIds}
                />
            </Modal>
        )
    }
}

/**
 * 备注弹窗
 */
class RemarkModal extends React.Component{

    constructor(props){
        super(props)
    }

    state = {
        visible: false,
        confirmLoading: false
    };

    fieldData = {};

    showModal = (record, mediaCode,okCallBack) => {
        this.setState({
            visible: true,
        });
        this.fieldData = {
            openId : {value : record.openid},
            mediaCode : {value : mediaCode},
            remark: {value : record.remark}
        };
        this.okCallBack = okCallBack;
    };

    okCallBack = () => {};

    handleOk = e => {
        console.log(e);
        this.setState({
            confirmLoading: true,
        });
        let WrappedRemarkForm = this.refs.wrappedRemarkForm;//通过refs属性可以获得对话框内form对象
        WrappedRemarkForm.validateFields((err, values) => {
            if(!err){
                let saveRemarkUrl = "/cm-sites-" + applicationName() + "/updateremark";
                postPublic(saveRemarkUrl, values,(res) =>{
                    if(res){
                        this.setState({
                            visible: false,
                            confirmLoading: false,
                            fieldData: {}
                        });
                        this.okCallBack();
                    }
                });
            }else{
                this.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
            confirmLoading: false,
            fieldData : {}
        });
    };

    render() {
        return(
            <Modal
                title={"修改备注"}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                confirmLoading={this.confirmLoading}
            >
                <WrappedRemarkForm fieldData={this.fieldData} ref={"wrappedRemarkForm"} />
            </Modal>
        );
    }
}

/**
 * 备注表单
 */
class RemarkForm extends React.Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form>
                {getFieldDecorator('openId')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('mediaCode')(
                    <Input type={"hidden"} />
                )}
                <Form.Item>
                {getFieldDecorator('remark',{
                    rules: [{type:'string',max:30,message: '备注不超过30字符!'}]
                })(
                    <Input placeholder="请输入备注" />
                )}
                </Form.Item>
            </Form>
        )
    }
}

const WrappedRemarkForm = Form.create()(RemarkForm);

/**
 * 标签管理弹窗
 */
class TagManageModal extends React.Component{
    constructor(props){
        super(props)
    }

    state = {
        title: "",
        visible: false,
        fieldData: {},
        confirmLoading: false
    };

    showModal = (title,groupId, tagName ,mediaCode,okCallBack) => {
        this.setState({
            title: title,
            visible: true,
            fieldData: {
                groupId : {value:groupId},
                mediaCode : {value:mediaCode},
                tagName: {value:tagName},
            }
        });
        this.okCallBack = okCallBack;
    };

    okCallBack = () => {};

    handleOk = e => {
        console.log(e);
        this.setState({
            confirmLoading: true,
        });
        let WrappedTagManageForm = this.refs.wrappedTagManageForm;//通过refs属性可以获得对话框内form对象
        WrappedTagManageForm.validateFields((err, values) => {
            if(!err){
                // 验证标签是否进行修改了
                if(values.tagName === this.state.fieldData.tagName.value){
                    this.setState({
                        visible: false,
                        confirmLoading: false,
                        fieldData: {}
                    });
                    return;
                }
                let validateTagUrl = "/cm-sites-" + applicationName() + "/tagIsExisting";
                postPublic(validateTagUrl, values,(res) =>{
                    if(res){
                        message.warn("当前标签已存在！");
                    }else {
                        let saveTagUrl = "/cm-sites-" + applicationName() + "/updateTag";
                        postPublic(saveTagUrl, values,(res) =>{
                            if(res){
                                this.setState({
                                    visible: false,
                                    confirmLoading: false,
                                    fieldData: {}
                                });
                                this.okCallBack(values.tagName);
                            }
                        });
                    }
                });
            }else{
                this.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
            confirmLoading: false,
            fieldData : {}
        });
    };

    render() {
        return(
            <Modal
                title={this.state.title}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                confirmLoading={this.confirmLoading}
            >
                <WrappedTagManageForm fieldData={this.state.fieldData} ref={"wrappedTagManageForm"} />
            </Modal>
        );
    }
}

/**
 * 标签管理表单
 */
class TagManageForm extends React.Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form>
                {getFieldDecorator('groupId')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('mediaCode')(
                    <Input type={"hidden"} />
                )}
                <Form.Item>
                {getFieldDecorator('tagName',{
                    rules: [{max:30, message: '标签名不超过30字符!'}]
                })(
                    <Input placeholder="请输入标签名" />
                )}
                </Form.Item>
            </Form>
        )
    }
}

const WrappedTagManageForm = Form.create()(TagManageForm);

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(WeChatFansManage);
